//import Amplify, { Auth } from 'aws-amplify';
import { Amplify } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';
import { signOut } from 'aws-amplify/auth';
import awsmobile from '../aws-exports';
//import api from '../api';
import { newAPIPost } from '../api/index.js';


export default {
  state: {
    isCheckingAuth: true,
    isLoggedIn: false,
    cognitoUser: null,
  },
  mutations: {
    updateCheckingAuth(state, isChecking) {
      state.isCheckingAuth = isChecking;
    },
    updateCurrentCognitoUser(state, user) {
      console.log(`updateCurrentCognitoUser`, user);
      state.cognitoUser = user;
      state.isLoggedIn = !!user;
    },
  },
  actions: {
    async checkAuth({ dispatch, commit }) {
      const currentAwsConfigJson = localStorage.getItem('currentAwsConfig');
      console.log('checkAuth, currentAwsConfigJson', currentAwsConfigJson);
      if (currentAwsConfigJson != null) {
        const currentAwsConfig = JSON.parse(currentAwsConfigJson);
        const mergedConfig = _(awsmobile)
          .extend(currentAwsConfig);
        console.log('mergedConfig', mergedConfig);
        Amplify.configure(mergedConfig);
        await dispatch('getUserProfile');
      }

      commit('updateCheckingAuth', false);
    },
    async userLoggedIn({ dispatch }, loginPayload) {
      console.log(`userLoggedIn`);
      localStorage.setItem('currentAwsConfig', JSON.stringify(loginPayload.awsConfig));
      await dispatch('getUserProfile');
    },
    async getUserProfile({ commit, dispatch }) {
      console.log(`getUserProfile`);
      try {
        //const cognitoUser = await Auth.currentAuthenticatedUser();
        const cognitoUser = await getCurrentUser();
        commit('updateCurrentCognitoUser', cognitoUser);
        dispatch('handleUserLoggedIn', cognitoUser.username);
      } catch (e) {
        console.log(`getUserProfile Error`, e);
        dispatch('logout');
      }
    },
    async logout({ commit }, shouldClearDevice) {
      try {
        const deviceKey = localStorage.getItem('deviceKey');
        localStorage.setItem("deviceKey", null);
        if (shouldClearDevice) {
          //const userProfile = await api.post('/api/w/users/me', {});
          const userProfile = await newAPIPost('/api/w/users/me', {});
          if (userProfile.currentDeviceKey === deviceKey) {
            //await api.post('/api/w/users/me/device', {});
            await newAPIPost('/api/w/users/me/device', {});
          }
        }
      } finally {
        //Auth.signOut();
        signOut();
        localStorage.clear();
        window.location.reload(true);
      }
    },
  },
  getters: {},
};
